import { ScnMainData } from "../scn/app";

export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function getAgencyIdsFromDataContext(dataContext: ScnMainData | null): string[] {
  if (dataContext?.agency_id) {
    return [dataContext.agency_id];
  }
  if (dataContext?.agenciesOfRg4?.length) {
    return dataContext.agenciesOfRg4.map(agency => agency.agency_id);
  }
  // RG2 global view: agencies list with `id` field
  if (dataContext?.agencies?.length) {
    return dataContext.agencies.map(agency => agency.id);
  }
  return [];
}

export function formatFrenchPhoneDisplay(phone?: string | null): string {
  if (!phone) return ""
  // Garder uniquement chiffres et +
  let cleaned = phone.replace(/[^\d+]/g, "")
  // +33 / 0033 → 0…
  if (cleaned.startsWith("+33")) cleaned = "0" + cleaned.slice(3)
  else if (cleaned.startsWith("0033")) cleaned = "0" + cleaned.slice(4)
  // Si on a 9 chiffres après normalisation (ex: +33778882853 → 0778882853)
  // le "0" a déjà été ajouté ci-dessus
  // Cas "+3306…" → "006…" : corriger le double 0
  cleaned = cleaned.replace(/^00/, "0")
  const digits = cleaned.replace(/\D/g, "")
  if (digits.length !== 10) return phone // fallback si format inattendu
  return digits.replace(/(\d{2})(?=\d)/g, "$1 ").trim()
}

export function canUseChatbot(coll: any): boolean {
  return coll.email.endsWith("@admin.fr") || coll.orga_id === "51fb094b-dc74-4e31-a77a-ea2ae37cc7a0"
}

/** Dictée CR (VoiceDraftCompteRendu) : tout le monde sauf 2 orgas. Modal chatbot inchangée. */
const VOICE_CR_BLOCKED_ORGA_IDS = new Set([
  "1c11e4e2-10d0-4d2d-8ad3-bb6bd064e52f",
  "f7795817-05ac-4a29-aa86-c6ddd0a53b1b",
])

export function canUseVoiceDraftCompteRendu(coll: any): boolean {
  return coll.email.endsWith("@admin.fr") || !VOICE_CR_BLOCKED_ORGA_IDS.has(coll.orga_id)
}